// extracted by mini-css-extract-plugin
export default {"container":"ClinicReviews_container__cJDV-"};